export const FETCH_PERSONS_LIST_START = 'FETCH_PERSONS_LIST_START';
export const FETCH_PERSONS_LIST_ERROR = 'FETCH_PERSONS_LIST_ERROR';
export const RECEIVE_PERSONS_LIST = 'RECEIVE_PERSONS_LIST';
export const CLEAR_PERSONS_LIST_STORE = 'CLEAR_PERSONS_LIST_STORE';

export const FETCH_PERSON_DETAILS_START = 'FETCH_PERSON_DETAILS_START';
export const FETCH_PERSON_DETAILS_ERROR = 'FETCH_PERSON_DETAILS_ERROR';
export const FETCH_PERSON_DETAILS_NOT_FOUND = 'FETCH_PERSON_PERSONAL_NOT_FOUND';
export const RECEIVE_PERSON_DETAILS = 'RECEIVE_PERSON_DETAILS';

export const SAVE_PERSON_DETAILS_START = 'SAVE_PERSON_DETAILS_START';
export const SAVE_PERSON_DETAILS_ERROR = 'SAVE_PERSON_DETAILS_ERROR';
export const SAVE_PERSON_DETAILS_SUCCESSFUL = 'SAVE_PERSON_DETAILS_SUCCESSFUL';

export const CLEAR_PERSON_DETAILS_STORE = 'CLEAR_PERSON_DETAILS_STORE';

export const ADD_PERSON_START = 'ADD_PERSON_START';
export const ADD_PERSON_ERROR = 'ADD_PERSON_ERROR';
export const ADD_PERSON_SUCCESSFUL = 'ADD_PERSON_DONE';

export const DELETE_PERSON_START = 'DELETE_PERSON_START';
export const DELETE_PERSON_ERROR = 'DELETE_PERSON_ERROR';
export const DELETE_PERSON_SUCCESSFUL = 'DELETE_PERSON_SUCCESSFUL';

export const SAVE_PERSON_PROFILE_PICTURE_START = 'SAVE_PERSON_PROFILE_PICTURE_START';
export const SAVE_PERSON_PROFILE_PICTURE_ERROR = 'SAVE_PERSON_PROFILE_PICTURE_ERROR';
export const SAVE_PERSON_PROFILE_PICTURE_DONE = 'SAVE_PERSON_PROFILE_PICTURE_DONE';

export const REMOVE_PERSON_PROFILE_PICTURE_START = 'REMOVE_PERSON_PROFILE_PICTURE_START';
export const REMOVE_PERSON_PROFILE_PICTURE_DONE = 'REMOVE_PERSON_PROFILE_PICTURE_DONE';
export const REMOVE_PERSON_PROFILE_PICTURE_ERROR = 'REMOVE_PERSON_PROFILE_PICTURE_ERROR';

export const FETCH_PERSON_PROGRAMS_START = 'FETCH_PERSON_PROGRAMS_START';
export const FETCH_PERSON_PROGRAMS_ERROR = 'FETCH_PERSON_PROGRAMS_ERROR';
export const RECEIVE_PERSON_PROGRAMS = 'RECEIVE_PERSON_PROGRAMS';
export const CLEAR_PERSON_PROGRAMS_STORE = 'CLEAR_PERSON_PROGRAMS_STORE';
export const ADD_PERSON_ASSIGNED_PROGRAM_TO_PROGRAMS = 'ADD_PERSON_ASSIGNED_PROGRAM_TO_PROGRAMS';

export const FETCH_PERSONS_SEMANTIC_KEY_WORD_OPERATIONS_LIST_START = 'FETCH_PERSONS_SEMANTIC_KEY_WORD_OPERATIONS_LIST_START';
export const FETCH_PERSONS_SEMANTIC_KEY_WORD_OPERATIONS_LIST_ERROR = 'FETCH_PERSONS_SEMANTIC_KEY_WORD_OPERATIONS_LIST_ERROR';
export const RECEIVE_PERSONS_SEMANTIC_KEY_WORD_OPERATIONS_LIST = 'RECEIVE_PERSONS_SEMANTIC_KEY_WORD_OPERATIONS_LIST';
export const CLEAR_PERSONS_SEMANTIC_KEY_WORD_OPERATIONS_LIST_STORE = 'CLEAR_PERSONS_SEMANTIC_KEY_WORD_OPERATIONS_LIST_STORE';

export const FETCH_PERSON_SEMANTIC_KEY_WORD_OPERATIONS_SELECTED_START = 'FETCH_PERSON_SEMANTIC_KEY_WORD_OPERATIONS_SELECTED_START';
export const FETCH_PERSON_SEMANTIC_KEY_WORD_OPERATIONS_SELECTED_ERROR = 'FETCH_PERSON_SEMANTIC_KEY_WORD_OPERATIONS_SELECTED_ERROR';
export const RECEIVE_PERSON_SEMANTIC_KEY_WORD_OPERATIONS_SELECTED = 'RECEIVE_PERSON_SEMANTIC_KEY_WORD_OPERATIONS_SELECTED';
export const CLEAR_PERSON_SEMANTIC_KEY_WORD_OPERATIONS_SELECTED_STORE = 'CLEAR_PERSON_SEMANTIC_KEY_WORD_OPERATIONS_SELECTED_STORE';
export const SAVE_PERSON_SEMANTIC_KEY_WORD_OPERATIONS_SELECTED_START = 'SAVE_PERSON_SEMANTIC_KEY_WORD_OPERATIONS_SELECTED_START';
export const SAVE_PERSON_SEMANTIC_KEY_WORD_OPERATIONS_SELECTED_SUCCESSFUL = 'SAVE_PERSON_SEMANTIC_KEY_WORD_OPERATIONS_SELECTED_SUCCESSFUL';
export const SAVE_PERSON_SEMANTIC_KEY_WORD_OPERATIONS_SELECTED_ERROR = 'SAVE_PERSON_SEMANTIC_KEY_WORD_OPERATIONS_SELECTED_ERROR';

export const FETCH_PERSON_CATEGORY_START = 'FETCH_PERSON_CATEGORY_START';
export const FETCH_PERSON_CATEGORY_ERROR = 'FETCH_PERSON_CATEGORY_ERROR';
export const FETCH_PERSON_CATEGORY_NOT_FOUND = 'FETCH_PERSON_CATEGORY_NOT_FOUND';
export const RECEIVE_PERSON_CATEGORY = 'RECEIVE_PERSON_CATEGORY';
export const CLEAR_PERSON_CATEGORY_STORE = 'CLEAR_PERSON_CATEGORY_STORE';
export const SAVE_PERSON_CATEGORY_START = 'SAVE_PERSON_CATEGORY_START';
export const SAVE_PERSON_CATEGORY_SUCCESSFUL = 'SAVE_PERSON_CATEGORY_SUCCESSFUL';
export const SAVE_PERSON_CATEGORY_ERROR = 'SAVE_PERSON_CATEGORY_ERROR';

export const FETCH_PERSON_SETTINGS_TRACKED_MEASUREMENTS_START = 'FETCH_PERSON_SETTINGS_TRACKED_MEASUREMENTS_START';
export const FETCH_PERSON_SETTINGS_TRACKED_MEASUREMENTS_ERROR = 'FETCH_PERSON_SETTINGS_TRACKED_MEASUREMENTS_ERROR';
export const FETCH_PERSON_SETTINGS_TRACKED_MEASUREMENTS_NOT_FOUND = 'FETCH_PERSON_SETTINGS_TRACKED_MEASUREMENTS_NOT_FOUND';
export const RECEIVE_PERSON_SETTINGS_TRACKED_MEASUREMENTS = 'RECEIVE_PERSON_SETTINGS_TRACKED_MEASUREMENTS';
export const CLEAR_PERSON_SETTINGS_TRACKED_MEASUREMENTS_STORE = 'CLEAR_PERSON_SETTINGS_TRACKED_MEASUREMENTS_STORE';
export const SAVE_PERSON_SETTINGS_TRACKED_MEASUREMENTS_START = 'SAVE_PERSON_SETTINGS_TRACKED_MEASUREMENTS_START';
export const SAVE_PERSON_SETTINGS_TRACKED_MEASUREMENTS_SUCCESSFUL = 'SAVE_PERSON_SETTINGS_TRACKED_MEASUREMENTS_SUCCESSFUL';
export const SAVE_PERSON_SETTINGS_TRACKED_MEASUREMENTS_ERROR = 'SAVE_PERSON_SETTINGS_TRACKED_MEASUREMENTS_ERROR';

export const FETCH_PERSON_SETTINGS_MEASUREMENTS_GENERAL_START = 'FETCH_PERSON_SETTINGS_MEASUREMENTS_GENERAL_START';
export const FETCH_PERSON_SETTINGS_MEASUREMENTS_GENERAL_ERROR = 'FETCH_PERSON_SETTINGS_MEASUREMENTS_GENERAL_ERROR';
export const FETCH_PERSON_SETTINGS_MEASUREMENTS_GENERAL_NOT_FOUND = 'FETCH_PERSON_SETTINGS_MEASUREMENTS_GENERAL_NOT_FOUND';
export const RECEIVE_PERSON_SETTINGS_MEASUREMENTS_GENERAL = 'RECEIVE_PERSON_SETTINGS_MEASUREMENTS_GENERAL';
export const CLEAR_PERSON_SETTINGS_MEASUREMENTS_GENERAL_STORE = 'CLEAR_PERSON_SETTINGS_MEASUREMENTS_GENERAL_STORE';
export const SAVE_PERSON_SETTINGS_MEASUREMENTS_GENERAL_START = 'SAVE_PERSON_SETTINGS_MEASUREMENTS_GENERAL_START';
export const SAVE_PERSON_SETTINGS_MEASUREMENTS_GENERAL_SUCCESSFUL = 'SAVE_PERSON_SETTINGS_MEASUREMENTS_GENERAL_SUCCESSFUL';
export const SAVE_PERSON_SETTINGS_MEASUREMENTS_GENERAL_ERROR = 'SAVE_PERSON_SETTINGS_MEASUREMENTS_GENERAL_ERROR';

export const FETCH_PERSON_MEASUREMENTS_START = 'FETCH_PERSON_MEASUREMENTS_START';
export const FETCH_PERSON_MEASUREMENTS_ERROR = 'FETCH_PERSON_MEASUREMENTS_ERROR';
export const RECEIVE_PERSON_MEASUREMENTS = 'RECEIVE_PERSON_MEASUREMENTS';
export const CLEAR_PERSON_MEASUREMENTS_STORE = 'CLEAR_PERSON_MEASUREMENTS_STORE';
export const ADD_PERSON_MEASUREMENT_START = 'ADD_PERSON_MEASUREMENT_START';
export const ADD_PERSON_MEASUREMENT_SUCCESSFUL = 'ADD_PERSON_MEASUREMENT_SUCCESSFUL';
export const ADD_PERSON_MEASUREMENT_ERROR = 'ADD_PERSON_MEASUREMENT_ERROR';
export const EDIT_PERSON_MEASUREMENT_START = 'EDIT_PERSON_MEASUREMENT_START';
export const EDIT_PERSON_MEASUREMENT_SUCCESSFUL = 'EDIT_PERSON_MEASUREMENT_SUCCESSFUL';
export const EDIT_PERSON_MEASUREMENT_ERROR = 'EDIT_PERSON_MEASUREMENT_ERROR';
export const DELETE_PERSON_MEASUREMENT_START = 'DELETE_PERSON_MEASUREMENT_START';
export const DELETE_PERSON_MEASUREMENT_SUCCESSFUL = 'DELETE_PERSON_MEASUREMENT_SUCCESSFUL';
export const DELETE_PERSON_MEASUREMENT_ERROR = 'DELETE_PERSON_MEASUREMENT_ERROR';

export const FETCH_PERSON_MEASUREMENT_START = 'FETCH_PERSON_MEASUREMENT_START';
export const FETCH_PERSON_MEASUREMENT_ERROR = 'FETCH_PERSON_MEASUREMENT_ERROR';
export const FETCH_PERSON_MEASUREMENT_NOT_FOUND = 'FETCH_PERSON_MEASUREMENT_NOT_FOUND';
export const RECEIVE_PERSON_MEASUREMENT = 'RECEIVE_PERSON_MEASUREMENT';
export const CLEAR_PERSON_MEASUREMENT_STORE = 'CLEAR_PERSON_MEASUREMENT_STORE';

export const ASSIGN_PERSON_PROGRAM_START = 'ASSIGN_PERSON_PROGRAM_START';
export const ASSIGN_PERSON_PROGRAM_SUCCESSFUL = 'ASSIGN_PERSON_PROGRAM_SUCCESSFUL';
export const ASSIGN_PERSON_PROGRAM_ERROR = 'ASSIGN_PERSON_PROGRAM_ERROR';
export const CLEAR_ASSIGN_PERSON_PROGRAM_STORE = 'CLEAR_ASSIGN_PERSON_PROGRAM_STORE';

export const ADD_MEASUREMENT_TO_PERSON_MEASUREMENTS = 'ADD_MEASUREMENT_TO_PERSON_MEASUREMENTS';
export const EDIT_MEASUREMENT_TO_PERSON_MEASUREMENTS = 'EDIT_MEASUREMENT_TO_PERSON_MEASUREMENTS';
export const DELETE_MEASUREMENT_FROM_PERSON_MEASUREMENTS = 'DELETE_MEASUREMENT_FROM_PERSON_MEASUREMENTS';

export const FETCH_PERSON_LIFE_STAGES_LIST_START = 'FETCH_PERSON_LIFE_STAGES_LIST_START';
export const FETCH_PERSON_LIFE_STAGES_LIST_ERROR = 'FETCH_PERSON_LIFE_STAGES_LIST_ERROR';
export const RECEIVE_PERSON_LIFE_STAGES_LIST = 'RECEIVE_PERSON_LIFE_STAGES_LIST';
export const CLEAR_PERSON_LIFE_STAGES_LIST_STORE = 'CLEAR_PERSON_LIFE_STAGES_LIST_STORE';

export const CREATE_PERSON_PROGRAM_START = 'CREATE_PERSON_PROGRAM_START';
export const CREATE_PERSON_PROGRAM_SUCCESSFUL = 'CREATE_PERSON_PROGRAM_SUCCESSFUL';
export const CREATE_PERSON_PROGRAM_ERROR = 'CREATE_PERSON_PROGRAM_ERROR';
export const CLEAR_CREATE_PERSON_PROGRAM_STORE = 'CLEAR_CREATE_PERSON_PROGRAM_STORE';

export const FETCH_PERSON_OCCUPIED_DATES_START = 'FETCH_PERSON_OCCUPIED_DATES_START';
export const FETCH_PERSON_OCCUPIED_DATES_ERROR = 'FETCH_PERSON_OCCUPIED_DATES_ERROR';
export const RECEIVE_PERSON_OCCUPIED_DATES_SUCCESSFUL = 'RECEIVE_PERSON_OCCUPIED_DATES_SUCCESSFUL';
export const CLEAR_PERSON_OCCUPIED_DATES_STORE = 'CLEAR_PERSON_OCCUPIED_DATES_STORE';

export const SET_PERSON_EVOLUTION_CONFIGURED = 'SET_PERSON_EVOLUTION_CONFIGURED';

export const SEND_PERSON_ACCOUNT_ACTIVATION_TOKEN_START = 'SEND_PERSON_ACCOUNT_ACTIVATION_TOKEN_START';
export const SEND_PERSON_ACCOUNT_ACTIVATION_TOKEN_ERROR = 'SEND_PERSON_ACCOUNT_ACTIVATION_TOKEN_ERROR';
export const SEND_PERSON_ACCOUNT_ACTIVATION_TOKEN_SUCCESSFUL = 'SEND_PERSON_ACCOUNT_ACTIVATION_TOKEN_SUCCESSFUL';

export const SET_PERSON_STATUS_START = 'SET_PERSON_STATUS_START';
export const SET_PERSON_STATUS_SUCCESSFUL = 'SET_PERSON_STATUS_SUCCESSFUL';
export const SET_PERSON_STATUS_ERROR = 'SET_PERSON_STATUS_ERROR';



// WEBPACK FOOTER //
// ./src/store/modules/persons/mutation-types.js